import { Button, ModalBody, ModalFooter } from '@chakra-ui/react';
import Balance from '@ui/components/Balance/Balance';
import { useTranslations } from '@ui/i18n';
import { parseValue } from '@ui/utils/format';
import {
  LiquidityStrategyTokenDict,
  useDepositTokenBalanceUsd,
} from '@ui/utils/strategy';

import { ReceiveRows } from '../ReceiveRows';
import { useDepositDrawer } from './useDepositDrawer';
import { useDeposit, useWithdraw } from './utils';

export const DefaultContent = () => {
  const t = useTranslations();

  const isWithdraw = useDepositDrawer((s) => s.isWithdraw);
  const token = useDepositDrawer((s) => s.token);
  const amountStr = useDepositDrawer((s) => s.amountStr);

  const tokenInfo = LiquidityStrategyTokenDict[token];
  const amountBn = parseValue(amountStr, 18);
  const amountUsd = useDepositTokenBalanceUsd({
    token,
    amount: amountBn,
  });

  const depositMutation = useDeposit();
  const withdrawMutation = useWithdraw();

  return (
    <>
      <ModalBody>
        <Balance
          title={isWithdraw ? t('Amount to withdraw') : t('Amount to deposit')}
          icon={<tokenInfo.Icon width="32px" height="32px" />}
          amount={parseValue(amountStr, 18)}
          usdAmount={amountUsd}
          usdDisplayDecimals={3}
          showUsdAmount
        />
        <ReceiveRows
          isWithdraw={isWithdraw}
          token={token}
          amountStr={amountStr}
          mt="36px"
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            if (isWithdraw) {
              withdrawMutation.mutate();
            } else {
              depositMutation.mutate();
            }
          }}
        >
          {isWithdraw ? t('Confirm withdraw') : t('Confirm deposit')}
        </Button>
      </ModalFooter>
    </>
  );
};
